import { render } from "./TheIssuesContainer.vue?vue&type=template&id=27dac648"
import script from "./TheIssuesContainer.vue?vue&type=script&lang=js"
export * from "./TheIssuesContainer.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__